<template>
    <div class="img-list">
        <template v-for="(item, index) in list">
            <el-image class="img" v-if="isVideo(item)" :src="item" fit="cover" :lazy="true" :key="index" @click="viewPicture(item)"></el-image>
            <div v-else class="video-box img iconfont iconzanting" @click="play(item)"></div>
        </template>
        <div class="img-masker" v-show="show" @click="closeViewPicture">
            <el-image class="big-image" :src="activeUrl" fit="contain" @click.stop></el-image>
            <span class="colse-image el-icon-circle-close" @click="closeViewPicture"></span>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'MyImgList',
      props: {
        list: {
          type: Array,
          default: () => {
            return [];
          }
        }
      },

      data() {
        return {
          show: false,
          activeUrl: '',
        };
      },
      methods: {

        /**
             * 查看大图
             * @param {String} url 当前图片地址
             */
        viewPicture(url) {
          this.activeUrl = url;
          this.show = true;
        },

        play(item) {
          this.$video.play(item);
        },

        /**
             * 判断是否音视频
             * 
             * @param {String} url 当前资源地址
             */
        isVideo(url) {
          let extension = url && url.length && url.substring(url.lastIndexOf('.')+1);
          if (extension === 'mp4' || extension === 'mp3' || extension === 'amr') {
            return false;
          }
          return true;    
        },

        /**
             * 关闭大图显示
             */
        closeViewPicture() {
          this.show = false;
        }
      }
    };
</script>

<style lang="scss" scoped>
    .img-list {

        .img {
            float: left;
            width: 80px;
            height: 80px;
            margin: 0 10px 10px 0;
            cursor: pointer;
        }

        .video-box {
            text-align: center;
            line-height: 80px;
            font-size: 30px;
            color: #fff;
            background-color: #000;
        }

        .img-masker {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 2000;
            width: 100%;
            height: 100%;
            text-align: center;
            background-color: rgba($color: #000000, $alpha: 0.6);

            .big-image {
                display: inline-block;
                width: auto;
                height: 100%;
            }

            .colse-image {
                position: absolute;
                right: 20px;
                top: 20px;
                color: #fff;
                font-size: 30px;
                cursor: pointer;
            }
        }
    }
</style>

<style lang="scss">


        .img-list {

            .img-masker {

                .el-image__inner {
                    width: auto;
                }
            }
        }
    
</style>
